import Lenis from "lenis";

let lenis = null;

export const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export function startLenis() {
  if (lenis || prefersReducedMotion()) return () => {};
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  let id;
  const raf = (t) => { lenis?.raf(t); id = requestAnimationFrame(raf); };
  id = requestAnimationFrame(raf);
  return () => { cancelAnimationFrame(id); lenis?.destroy(); lenis = null; };
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
  setTimeout(() => {
    const f = el.querySelector("[data-autofocus]") || el;
    f.focus?.({ preventScroll: true });
  }, 700);
}
